export default "__VITE_ASSET__hufEVBK5__"